import React, { useCallback, useMemo } from "react";
import { WidgetEmployeeLeaveSettingsStackScreenProps } from "./WidgetEmployeeLeaveSettingsStack";
import { ListItem, SelectList, SelectListItem } from "arkh";
import { graphql, useLazyLoadQuery } from "react-relay";
import { LazyQueryNetworkBoundrary } from "@/src/components/mobile/QueryNetworkBoundrary";

import { FormattedMessage } from "react-intl";
import { useWidgetSettingsEmployeeLeaveContext } from "./WidgetEmployeeLeaveSettingsContext";
import { WidgetEmployeeLeaveSettingsLeaveReasonsQuery } from "./__generated__/WidgetEmployeeLeaveSettingsLeaveReasonsQuery.graphql";

function WidgetEmployeeLeaveSettingsLeaveReasonsC({
  fetchKey,
}: {
  fetchKey: string;
}) {
  const { leaveReasonIds, setLeaveReasonIds } =
    useWidgetSettingsEmployeeLeaveContext();
  const data = useLazyLoadQuery<WidgetEmployeeLeaveSettingsLeaveReasonsQuery>(
    graphql`
      query WidgetEmployeeLeaveSettingsLeaveReasonsQuery {
        store {
          id
          leaveReasons {
            id
            leaveReason
          }
        }
      }
    `,
    {},
    {
      fetchKey,
      fetchPolicy: "store-and-network",
    }
  );

  const leaveReasons = useMemo(
    () => data.store.leaveReasons ?? [],
    [data.store.leaveReasons]
  );

  const renderItem = useCallback(
    ({
      item,
      index,
    }: {
      item: (typeof leaveReasons)[number];
      index: number;
    }) => {
      const selected = leaveReasonIds.includes(item.id);
      return (
        <SelectListItem
          onPress={() => {
            setLeaveReasonIds((prev) => {
              const selected = prev.includes(item.id);
              if (selected) {
                return prev.filter((id) => id !== item.id);
              }
              return [...prev, item.id];
            });
          }}
          selected={selected}
          isFirst={index === 0}
          isLast={index === leaveReasons.length - 1}
        >
          <ListItem.Title>{item.leaveReason}</ListItem.Title>
        </SelectListItem>
      );
    },
    [leaveReasonIds, setLeaveReasonIds, leaveReasons]
  );

  return (
    <SelectList
      ListHeaderComponent={
        <ListItem
          right={
            <ListItem.SelectIndicator selected={leaveReasonIds.length === 0} />
          }
          isFree
          onPress={() => {
            setLeaveReasonIds([]);
          }}
          border="border-primary"
        >
          <ListItem.Title>
            <FormattedMessage
              description="LeaveReasonSelectList all leave reasons"
              defaultMessage="All reasons"
            />
          </ListItem.Title>
        </ListItem>
      }
      contentBox={{ spaceTop: "medium" }}
      data={leaveReasons}
      insets={{}}
      renderItem={renderItem}
    />
  );
}

export function WidgetEmployeeLeaveSettingsLeaveReasons(
  props: WidgetEmployeeLeaveSettingsStackScreenProps<"WELSLeaveReasons">
) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fk) => <WidgetEmployeeLeaveSettingsLeaveReasonsC fetchKey={fk} />}
    </LazyQueryNetworkBoundrary>
  );
}
